(function($) {
    
$(function(){
    $('#myVideoModal').modal({
        show: false
    }).on('hidden.bs.modal', function(){
        $(this).find('video')[0].pause();
    });
  });

  
$(function(){
    $('#myVideoModalLeft').modal({
        show: false
    }).on('hidden.bs.modal', function(){
        $(this).find('video')[0].pause();
    });
  });
  
  })(jQuery);